import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectBuyPackageModalData,
  selectIsBuyPackageModalAutoprolongAvailable,
} from '../../../../selectors/buyPackageModal';
import { Autoprolong } from './Autoprolong';
import { setBuyPackageModalAutoProlong } from '../../../../slices';

export const AutoprolongContainer = () => {
  const { autoProlong } = useSelector(selectBuyPackageModalData);
  const isAvailable = useSelector(selectIsBuyPackageModalAutoprolongAvailable);

  const dispatch = useDispatch();

  const handleChange = React.useCallback(
    (_: React.ChangeEvent, autoProlong: boolean) => {
      dispatch(setBuyPackageModalAutoProlong(autoProlong));
    },
    [dispatch],
  );

  if (!isAvailable) {
    return null;
  }

  return <Autoprolong autoProlong={autoProlong} onChange={handleChange} />;
};
